/**
 * Client instrumentation entrypoint — Next runs this on the browser before the
 * app hydrates. Installs the closed-loop client capture: global error handlers
 * + the telemetry reporter (dormant until NEXT_PUBLIC_TELEMETRY_INGEST_PATH is
 * set). Kept tiny so it can't delay first paint.
 */

import { initClientObservability } from "@/shared/observability/capture";

initClientObservability();
